module.exports = __webpack_public_path__ + "fonts/SUIT-Regular.f6bc1a63.woff2";